import { render, staticRenderFns } from "./light.vue?vue&type=template&id=e5667c00"
import script from "./light.vue?vue&type=script&lang=js"
export * from "./light.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports